import { LUCK_LABEL, luckGain, statusGainEntries } from '@/lib/status-gain'
import type { Achievement } from '@/types'

type Props = {
  statusGain: Achievement['status_gain']
  earnedPoints: number
  isAiAnalyzed: boolean
}

export default function StatusGainBadge({ statusGain, earnedPoints, isAiAnalyzed }: Props) {
  if (!isAiAnalyzed || earnedPoints === 0) return null

  const stats = statusGainEntries(statusGain)
  const luck = luckGain(statusGain)

  if (stats.length === 0 && luck === 0) return null

  return (
    <div className="space-y-1.5">
      <p className="text-xs font-medium text-muted-foreground">ステータス獲得</p>
      <div className="flex flex-wrap items-center gap-1.5">
        {stats.map(({ key, label, val }) => (
          <span key={key} className="text-xs px-2 py-0.5 rounded-full bg-blue-500/10 text-blue-700 dark:text-blue-400">
            {label} +{val}
          </span>
        ))}
        {luck !== 0 && (
          <span className={`text-xs px-2 py-0.5 rounded-full ${
            luck > 0
              ? 'bg-green-500/10 text-green-700 dark:text-green-400'
              : 'bg-red-500/10 text-red-700 dark:text-red-400'
          }`}>
            {LUCK_LABEL} {luck > 0 ? `+${luck}` : luck}
          </span>
        )}
        <span className="text-xs text-muted-foreground ml-1">{earnedPoints} pt</span>
      </div>
    </div>
  )
}
